<template>
  <div>
    <the-nav-bar :title="$t('payInfo.addPayment')" />
    <md-field :brief="$t('payInfo.recommand')">
      <md-radio-list
        v-model="current"
        :options="payMethods"
        icon="right"
        icon-inverse=""
        icon-position="right"
      >
        <template slot-scope="{ option }">
          <div class="radio-content row-align-center">
            <img :src="option.icon" :alt="option.text" class="icon" />
            <span class="text">{{ option.text }}</span>
          </div>
        </template>
      </md-radio-list>
      <div class="btn-wrapper" slot="footer">
        <md-button :type="!current ? 'disabled' : 'primary'" @click="goNext">
          <span>{{ $t('payInfo.next') }}</span>
        </md-button>
      </div>
    </md-field>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Field, Button, RadioList } from 'mand-mobile';
import getPayIcon from '@/utils/get-payment-icon.js';

export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [RadioList.name]: RadioList,
  },
  data() {
    return {
      current: 'alipay',
    };
  },
  computed: {
    payMethods() {
      const map = {
        alipay: 'alipay',
        wechatpay: 'wechatpay',
        unionpay: 'bank',
      };
      return Object.entries(map).map(([key, value]) => {
        return {
          value: value,
          icon: getPayIcon(key),
          text: this.$t(`payments.${key}`),
        };
      });
    },
  },
  created() {
    // 添加完保证能正确返回
    let needBack = window.localStorage.getItem('needBack');
    if (needBack) {
      window.localStorage.removeItem('needBack');
      this.$router.go(-1);
      return;
    }
  },
  methods: {
    goNext() {
      this.$router.push({
        path: '/mine/payInfo/list/detail',
        query: {
          payMethod: this.current,
          isAdd: 1,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.md-field {
  padding: 4.8vw 0;

  & >>> {
    .md-field-header, .md-field-footer {
      padding: 0 4.8vw;
    }
  }

  .btn-wrapper {
    margin-top: 9.6vw;
  }
}

.md-radio-list {
  & >>> {
    .md-cell-item:nth-child(even) {
      background: #f8fbfc;
    }

    .md-cell-item-body {
      min-height: 17.07vw;
      padding-left: 4.8vw;
      padding-right: 4.8vw;

      &:before {
        content: none;
      }
    }

    .md-icon {
      font-size: 5.33vw;
      color: color-primary;
    }
  }

  .radio-content {
    .icon {
      width: 6.4vw;
      height: 6.4vw;
    }

    .text {
      margin-left: 2.67vw;
      font-size: 3.73vw;
    }
  }
}
</style>
